import { isNil } from 'lodash-es'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useState } from 'react'

import { formatDate, isNilOrEmptyString, StringDateRange } from '@/shared/lib'

export const useDateRange = () => {
  const searchParams = useSearchParams()

  const startDate = searchParams?.get('startDate')
  const endDate = searchParams?.get('endDate')

  const [dateRange, setDateRange] = useState<StringDateRange>()

  const updateDateRange = (dateRange?: StringDateRange) => {
    if (
      isNil(dateRange) ||
      isNilOrEmptyString(dateRange.from) ||
      isNilOrEmptyString(dateRange.to)
    ) {
      setDateRange(undefined)

      return
    }

    setDateRange(dateRange)
  }

  useEffect(() => {
    if (isNilOrEmptyString(startDate) || isNilOrEmptyString(endDate)) {
      return
    }

    const rangeFromSearchParams = {
      from: formatDate({ date: startDate, format: 'yyyy-MM-dd' }),
      to: formatDate({ date: endDate, format: 'yyyy-MM-dd' }),
    }

    const isStartDateSame = rangeFromSearchParams.from === dateRange?.from
    const isEndDateSame = rangeFromSearchParams.to === dateRange?.to

    if (isStartDateSame && isEndDateSame) {
      return
    }

    updateDateRange(rangeFromSearchParams)
  }, [startDate, endDate])

  return {
    dateRange,
    updateDateRange,
  }
}
